import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import './PaymentModal.css';

const PaymentModal = ({ isOpen, onClose, onPaymentSuccess }) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setIsProcessing(true);
    setError(null);

    // DÜZELTME: Artık confirmPayment kullanıyoruz.
    const { error: paymentError } = await stripe.confirmPayment({
      elements,
      // Bu redirect, ödeme sonrası ne olacağını belirler.
      // 'if_required' diyerek, sadece 3D Secure gibi ek bir adım
      // gerekiyorsa kullanıcıyı yönlendirmesini, aksi takdirde
      // kontrolü bize bırakmasını sağlıyoruz.
      redirect: 'if_required', 
    });

    if (paymentError) {
      if (paymentError.type === "card_error" || paymentError.type === "validation_error") {
        setError(paymentError.message);
      } else {
        setError(t('error_unexpected_payment'));
      }
      setIsProcessing(false);
      return;
    }
    
    // Eğer buraya ulaştıysak, ödeme başarılıdır.
    // Stripe, redirect: 'if_required' nedeniyle kontrolü bize geri verdi.
    onPaymentSuccess();
    setIsProcessing(false);
  };
  
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="payment-modal-overlay" onClick={isProcessing ? null : onClose}>
      <div className="payment-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h3>{t('secure_payment')}</h3>
          <button onClick={isProcessing ? null : onClose} className="close-btn">×</button>
        </div>
        <form onSubmit={handleSubmit} className="payment-form">
          <p>{t('enter_card_details')}</p>
          
          {/* DÜZELTME: CardElement yerine PaymentElement kullanılıyor */}
          <div className="payment-element-container">
            <PaymentElement />
          </div>

          {error && <div className="payment-error">{error}</div>}
          
          <button disabled={isProcessing || !stripe || !elements} className="pay-button">
            {isProcessing ? (
              <>{t('processing')} <i className="fas fa-spinner fa-spin"></i></>
            ) : (
              t('pay_now')
            )}
          </button>
        </form>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default PaymentModal;